<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part">
<h2><span class="h2-inner">Part One</span></h2>
<h3><span class="h3-inner">Naseby Field</span></h3>
<blockquote class=" bq">
<p class=" firstInSection">“I could not, riding out alone about my business, but smile out to God in praises, in assurance of victory because God would, by things that are not, bring to naught things that are.”</p>
</blockquote>
<p class="source firstInSection">Cromwell before the Battle of Naseby</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?59ffe944